<template>
  <BModalRaw
    ref="inner"
    :id="id"
    v-model="visible"
    :no-header="hideHeader"
    :no-footer="hideFooter"
    :no-trap="true"
    v-bind="$attrs"
  >
    <template v-if="hasHeaderSlot" #header="scope">
      <slot name="modal-header" v-bind="scope"><slot name="header" v-bind="scope" /></slot>
    </template>
    <template v-if="hasTitleSlot" #title="scope">
      <slot name="modal-title" v-bind="scope"><slot name="title" v-bind="scope" /></slot>
    </template>
    <template v-if="hasFooterSlot" #footer="scope">
      <slot name="modal-footer" v-bind="scope"><slot name="footer" v-bind="scope" /></slot>
    </template>
    <template #default="scope">
      <slot v-bind="scope" />
    </template>
  </BModalRaw>
</template>

<script>
import { BModal as BModalRaw } from 'bootstrap-vue-next';
import { registerModal, unregisterModal } from './bModalCompat';

export default {
  name: 'BModal',
  components: { BModalRaw },
  inheritAttrs: false,
  props: {
    id: { type: String, default: undefined },
    modelValue: { type: Boolean, default: undefined },
    hideHeader: { type: Boolean, default: false },
    hideFooter: { type: Boolean, default: false },
    noEnforceFocus: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  data() {
    return { visible: this.modelValue === true };
  },
  computed: {
    hasHeaderSlot() {
      return !!(this.$slots['modal-header'] || this.$slots.header);
    },
    hasTitleSlot() {
      return !!(this.$slots['modal-title'] || this.$slots.title);
    },
    hasFooterSlot() {
      return !!(this.$slots['modal-footer'] || this.$slots.footer);
    }
  },
  watch: {
    modelValue(val) {
      if (typeof val === 'boolean' && val !== this.visible) this.visible = val;
    },
    visible(val) {
      this.$emit('update:modelValue', val);
    }
  },
  mounted() {
    registerModal(this.id, this);
  },
  unmounted() {
    unregisterModal(this.id);
  },
  methods: {
    show() {
      const inner = this.$refs.inner;
      if (inner && typeof inner.show === 'function') inner.show();
      else this.visible = true;
    },
    hide(trigger) {
      const inner = this.$refs.inner;
      if (inner && typeof inner.hide === 'function') inner.hide(trigger);
      else this.visible = false;
    },
    toggle() {
      const inner = this.$refs.inner;
      if (inner && typeof inner.toggle === 'function') inner.toggle();
      else this.visible = !this.visible;
    }
  }
};
</script>
